import { render, staticRenderFns } from "./Centros.vue?vue&type=template&id=512b1c16&scoped=true"
import script from "./Centros.vue?vue&type=script&lang=js"
export * from "./Centros.vue?vue&type=script&lang=js"
import style0 from "./Centros.vue?vue&type=style&index=0&id=512b1c16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b1c16",
  null
  
)

export default component.exports